import { useJobList, useMap } from 'rwl-ui';
import { PluginWorkSite } from 'rwl-shared/dist/models';
import { useGlobal } from '../../hooks';
import { MapRenderer } from './MapRenderer';
import { useEffect, useState } from 'react';
import { boundsFromWorkSites } from 'rwl-shared/dist/utils/map';
import { Config } from '../../fetchers/ConfigFetcher/useConfig';
import { usePlacesAutocomplete } from '../../hooks/usePlacesAutocomplete';

function setZoom(
    map: google.maps.Map,
    workSites: PluginWorkSite[],
    config: Config,
    bounds: string | undefined,
    selectedPlaceDetails: google.maps.GeocoderResult | null
): void {
    // we don't want to move the map since they are searching for an explicit location
    if (bounds || selectedPlaceDetails) {
        return;
    }

    // if we have work sites, fit the bounds to them
    if (workSites?.length) {
        map?.fitBounds(
            boundsFromWorkSites(workSites, config.account.geolocation)
        );
        // focus on the account geolocation
    } else if (config.account?.geolocation?.lat) {
        map?.setCenter(config.account.geolocation);
        map?.setZoom(15);
    }
}

export function SalesToolMap(): JSX.Element | null {
    const [showMovedButton, setShowMovedButton] = useState(false);
    const { fitBounds, bounds, map, setApiKey } = useMap();
    const { selectedPlaceDetails, clearSelectedPlaceId } =
        usePlacesAutocomplete();
    const { jobList } = useJobList();
    const { config, brandColor } = useGlobal();

    // TODO: Move API Key into the global settings
    useEffect(() => {
        if (config) {
            setApiKey('AIzaSyDe_QvLwfkNqtQ5v-Nn0ISVMag_N5faWVY');
        }
    }, [config]);

    useEffect(() => {
        let boundsChangedListener: google.maps.MapsEventListener | undefined;
        let hasMovedOnce = false;

        if (map && !!selectedPlaceDetails?.place_id) {
            boundsChangedListener = map.addListener('bounds_changed', () => {
                if (hasMovedOnce) {
                    setShowMovedButton(true);
                }
                hasMovedOnce = true;
            });
        }

        return () => {
            if (boundsChangedListener) {
                boundsChangedListener.remove();
            }
        };
    }, [map, selectedPlaceDetails]);

    useEffect(() => {
        if (map && config) {
            setZoom(map, jobList, config, bounds, selectedPlaceDetails);
        }
    }, [map, config, jobList]);

    function updateMapBounds(): void {
        const bounds = map?.getBounds();
        if (bounds) {
            fitBounds(bounds, 0);
        }
    }

    if (!config) {
        return null;
    }
    return (
        <div
            id={'googleMap'}
            style={{
                width: '100%',
                height: '100%',
            }}
        >
            <MapRenderer
                workSites={jobList as any as PluginWorkSite[]}
                showMovedButton={showMovedButton}
                clearShowMovedButton={() => setShowMovedButton(false)}
                config={config}
                onClickSearch={() => {
                    clearSelectedPlaceId();
                    updateMapBounds();
                    setShowMovedButton(false);
                }}
                brandColor={brandColor}
            />
        </div>
    );
}
